import './style.css';

function Loader() {

  return (
    <div className='loader-span'>
      <div className='loader-span-animation'></div>
      <span className='loader-span-text'>Loading...</span>
    </div>
  
  )

}

export default Loader;
